import { UUID_REGEX_STRING } from 'utils/constants';

import { routes } from './routes';

export const isSectionRoute = (pathname: string) => pathname.startsWith(`${routes.menu}/section/`);

export const isRecentItemsRoute = (pathname: string) => pathname.startsWith(routes.menuRecent);

export const isFavoritesRoute = (pathname: string) => pathname.startsWith(routes.favorites);

export const isOfferItemRoute = (pathname: string) =>
  new RegExp(`^${routes.loyaltyOfferList}/${UUID_REGEX_STRING}`).test(pathname);

export const isItemPickerOrComboRoute = (pathname: string) =>
  new RegExp(`(item|picker|combo)/`).test(pathname);
